<template>
  <div class='home'>
    <Header></Header>
    <div class="content">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/HeaderVue.vue'
import Footer from "@/components/Footer.vue"
export default {
  data() {
    return {
      controlTop: ''
    }
  },
  created() {
    // console.log();
  },
  mounted() {
  },
  components: {
    Header,
    Footer

  },
  methods: {
  }
}
</script>
<style scoped lang='less'>
.home {
  flex: 1;
  background: rgba(241, 244, 246, 1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
}
</style>
